import { InputText } from "primereact/inputtext";
import FormContainer from "./FormContainer";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import useApi from "../hooks/ApiHook";

const PasswordResetForm = () => {
	const [ loading, setLoading ] = useState(false);
	const [ username, setUsername ] = useState('');
	const navigate = useNavigate();
	const api = useApi();

	const request = async () => {
		try {
			setLoading(true);
			const result = await api.post('change-password/request', { username });
			navigate(`./verify?email=${result.data.email}&username=${username}`);
		} catch (e) {
			console.log(e);
		} finally {
			setLoading(false);
		}
	}

	const submit = e => {
		e.preventDefault();
		request();
	}

	return (
		<FormContainer>
      <div className='text-3xl font-semibold text-black-alpha-90 mb-2'>
        Vamos resetar sua senha
      </div>
			<div className="mb-4 text-700">
				Preencha o seu e-mail abaixo para enviarmos um código de redefinição de senha
			</div>
      <form onSubmit={submit}>
        <div className="field">
          <label>Nome de usuário</label>
          <InputText 
						className='w-full' 
						placeholder='usuario@exemplo' 
						required
						value={username}
						onChange={e => setUsername(e.target.value)}/>
        </div>
        <div className="field">
          <Button className='w-full' label='Enviar'></Button>
        </div>
        <div className="field">
          <Button 
            className='w-full' 
            label='Cancelar' 
            severity="secondary"
            type='button'
						onClick={() => navigate('/')}/>
        </div>
      </form>
    </FormContainer>
	);
}

export default PasswordResetForm;